import React, {useState} from 'react';

import {useParams} from "react-router-dom";

import Header from "../../../layouts/Header";
import {getContent} from "../api/ProfileAPIs";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";
const ContentPage = () => {
    const {slug} = useParams();
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState('');

    React.useEffect(() => {
        setLoading(true);
        const fetchUserInfo = async () => {
            try {
                const data = await getContent(slug);
                setContent(data.data);
            } catch (err) {
                 showError( err);
            } finally {
                setLoading(false);
            }
        };
            fetchUserInfo();
    }, [slug]);

        if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title={content.title} hasBack={true}/>
            <section className="container  mt-3 py-3 rtl ">
                <div className="row mx-0 px-0">
                    <div className="col-12 px-0">
                        <img src={content.image} alt={content.title} className='w-100 content-pix' />
                    </div>
                    <div className="col-12 text-center fw-bold mt-3 text-big-1 border-bottom pb-3">
                        {content.title}
                    </div>
                    <div className="col-12 text-justify p-md-4">
                        <p  dangerouslySetInnerHTML={{ __html: content.content }}></p>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default ContentPage;